export const BondingMunhna = {
  _format: "hh-sol-artifact-1",
  contractName: "BondingMunhna",
  sourceName: "contracts/BondingMunhna.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "uint256",
          name: "precision",
          type: "uint256"
        },
        {
          internalType: "uint8",
          name: "_munhnaType",
          type: "uint8"
        },
        {
          internalType: "address",
          name: "_tokenA",
          type: "address"
        },
        {
          internalType: "address",
          name: "_tokenB",
          type: "address"
        }
      ],
      stateMutability: "nonpayable",
      type: "constructor"
    },
    {
      inputs: [],
      name: "InvalidAmount",
      type: "error"
    },
    {
      inputs: [],
      name: "InvalidMunhnaType",
      type: "error"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "buyer",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "cost",
          type: "uint256"
        }
      ],
      name: "Purchase",
      type: "event"
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "seller",
          type: "address"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "refund",
          type: "uint256"
        }
      ],
      name: "Sale",
      type: "event"
    },
    {
      inputs: [],
      name: "CURVE_PRECISION",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "DECIMALS",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256"
        }
      ],
      name: "buy",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "munhnaType",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "reserveBalance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [],
      name: "scalingFactor",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "_amount",
          type: "uint256"
        }
      ],
      name: "sell",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function"
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256"
        }
      ],
      stateMutability: "view",
      type: "function"
    }
  ],
  bytecode: "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",
  deployedBytecode: "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",
  linkReferences: {},
  deployedLinkReferences: {}
}
